module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"My Account","save":"Save profile","alert_title":"Success","alert_message":"Data successfully updated!"},"pt-BR":{"title":"Minha Conta","save":"Salvar dados","alert_title":"Sucesso","alert_message":"Dados atualizados com sucesso!"}}')
  delete Component.options._Ctor
}
